import BaseFilter from "./BaseFilter";

export default class TitleFilter extends BaseFilter {
	static input_selector_id = "title-filter";

	static shouldBeInitialized(): boolean {
		return document.getElementById(this.input_selector_id) != null;
	}

	sanitize(text: string): string {
		return text.toLowerCase().replace(/\W/gm, "");
	}

	shouldShow(gridItem: HTMLElement): boolean {
		const inputField = document.getElementById(TitleFilter.input_selector_id) as HTMLInputElement | null;
		if (!inputField) {
			console.warn(`Something is going very wrong here, ${TitleFilter.input_selector_id} was not found, aborting`);
			return true
		}

		let name = gridItem.dataset.name;
		if (!name) {
			console.warn('Something is going very wrong here, a grid item doesn\'t have name in the dataset, aborting');
			return true;
		}

		name = this.sanitize(name);
		let search = this.sanitize(inputField.value);

		return name.includes(search);
	}
}
